import { render, staticRenderFns } from "./DetailHover.vue?vue&type=template&id=4c288d2e&"
import script from "./DetailHover.vue?vue&type=script&lang=js&"
export * from "./DetailHover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports